"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShippingDashboardSearchResponse = void 0;
const common_1 = require("../../../common");
const shipping_dashboard_data_response_1 = require("./shipping-dashboard-data.response");
class ShippingDashboardSearchResponse extends common_1.PaginatedResponse {
}
exports.ShippingDashboardSearchResponse = ShippingDashboardSearchResponse;
//# sourceMappingURL=shipping-dashboard-search.response.js.map